<template>
    <div class="goodDetail">

        <Head :headInfo='headInfo' :slotShow='appVer' @onClickLeft='onBack' @onClickRight="onShareGoods">
            <div slot='iconImg' class="iconImg">
                <img src="../../../assets/img/b2b/icon_share@2x.png" alt="" v-if="appVer">
            </div>
        </Head>
        <!-- 商品banner图片 -->
        <BannerSwiper :isHotSale='goodData.isHotSale' :pageWidth='pageWidth' :imgUrlList='goodData.spuImgUrlList' />
        <!-- 商品title -->
        <div class="borderBot borderBotLeft0">
            <GoodTitle :pricesList='pricesList' :salesPrice='salesPrice' :retailPrice='retailPrice' :spuName='goodData.spuName' />
        </div>
        <!-- 销售区域 -->
        <div class="mtop20 positionR borderBot borderBotLeft0">
            <Region v-if="spuSalesAreaShow" :spuSalesAreaList='spuSalesArea' :spuShow='true' />
        </div>
        <!-- 优惠券 -->
        <Services v-if="goodData && goodData.categoryId && goodsId" :servicesData="{'categoryId': goodData.categoryId, 'goodsId': goodsId}" />
        <!-- 选择规格 -->
        <div class="mark arrow2 mtop20 col999" @click="onPopup(3)" v-if="specsName">
            已选<div class="item"><span v-text="specsName"></span></div>
        </div>
        <!-- 正品保障 -->
        <div class="mtop20">
            <Server />
        </div>
        <!-- 商品资料包 -->
        <div class="mtop20" v-if="goodsId">
            <Means v-if="goodsId" :goodsId='goodsId' />
        </div>
        <!-- 店铺小店 -->
        <div class="mtop20" v-if="shopName">
            <ShopName v-if="shopName" :shopName='shopName' />
        </div>
        <!-- 店铺介绍 -->
        <div class="mtop20">
            <Content :detail='goodData.detail' />
        </div>
        <!-- 底部 -->
        <div v-if="$isApproveShow()">
            <ButFoot :isStar='isStar' :wCartNum='wCartNum' @onPopup='onPopup' />
        </div>
        <div v-else>
            <div class="foot approve">
                <div class="btn" @click="onPen">认证后可购买</div>
            </div>
        </div>
        <!-- sku弹窗 -->
        <Sku :visible.sync='skuPopup' :merchantCode='goodData.merchantCode' :getSpecsList='getSpecsList' :skuDetailListArr='skuDetailList' :optionTypesArr='optionTypes' :skuGood='skuGood' :spuInfo='spuInfo' :defActive='defActive' v-if="skuDetailList.length" @onSpecs='onSpecs'
            @selectData='setGoodData' @initSkuGood='initSkuGood' @cartNums='cartNums' @getPoint='getPoint' @buryPoint='buryPoint' />
        <!-- 在线客服 -->
        <CustomerService :goodInfo='goodInfo' />
    </div>
</template>
<script>
import Head from '../../common/head'
import { Toast } from 'vant'
import { clearCache } from '@/utils/index'
import { mapState, mapActions } from 'vuex'
import { versions } from '../../common/version'
import { getInvitationCode, shopInfo } from '../api/api'
import { getGoodsDetail, isPriceData, isCollect, addFavorite, cancelFavorite, getSpecs } from '../api/product'
import Region from '../common/detail/region' // 销售区域
import GoodTitle from '../common/detail/goodTitle' // 商品名称
import BannerSwiper from '../common/detail/bannerSwiper' // banner详情
import ShopName from '../common/shopNameTemplate' // 小店
import Server from '../common/detail/server/index' // 服务协议
import Content from '../common/detail/content' // 商品介绍
import Services from '../common/detail/services/index' // 优惠信息
import Means from '../common/detail/means/index' // 商品资料
import Sku from '../common/sku' // sku弹出层
import ButFoot from './common/btnFoot' // 底部foot
import CustomerService from '../common/customerService' // 在线客服
export default {
    name: 'goodsDetail',
    components: {
        Head,
        BannerSwiper,
        Region,
        ShopName,
        Content,
        Services,
        CustomerService,
        Means,
        Server,
        ButFoot,
        GoodTitle,
        Sku
    },
    data () {
        return {
            headInfo: {
                title: '商品详情'
            },
            userInfo: {}, // 用户信息
            goodsId: this.$route.query.id, // 商品id
            spuInfo: {}, // spu信息
            appVer: false, // 是否显示分享图标
            pageWidth: document.documentElement.clientWidth, // banner图片宽度
            goodData: {}, // 商品详情
            skuPopup: false, // sku显示弹窗
            isPrice: true, // 是否可以进行购买
            shopName: '', // 店铺信息名称
            invitationCode: '', // 商户邀请码
            isStar: false, // 是否显示收藏按钮
            spuSalesAreaShow: false,
            detail: '', // 商品介绍
            getSpecsList: [], // 规格列表
            pricesList: [], // 阶梯价
            goodInfo: {}, // 客服信息
            specsName: '', // 规格名称
            salesPrice: [],
            retailPrice: [],
            skuGood: {}, // sku信息
            skuDetailList: [],
            optionTypes: [],
            spuSalesArea: [],
            defActive: []
        }
    },
    computed: {
        ...mapState({
            wCartNum: state => state.b2b.cartNum
        })
    },
    methods: {
        ...mapActions(['setBuried', 'getCartNums']),
        onBack () {
            if (!this.$route.query.isShare) {
                if (parseInt(this.tab)) {
                    localStorage.removeItem('activityData')
                    this.$router.replace({ path: '/b2b/home/index' })
                } else if (this.goodsDetailBack) {
                    localStorage.removeItem('activityData')
                    this.$router.replace({ path: this.goodsDetailBack })
                } else {
                    this.$router.back(-1)
                }
            } else {
                if (this.goodsDetailBack) {
                    this.$router.push({ path: this.goodsDetailBack })
                } else {
                    this.$router.push({ path: '/b2b/home/index' })
                }
            }
        },
        // 未认证跳转
        onPen () {
            this.$router.push({ path: '/b2b/company/index' })
        },
        // 分享
        onShareGoods () {
            // 0001 分享次数
            this.buryPoint(86)
            let shareUrl = '/b2b/goods/shareGoods'
            let shareTitle = this.goodData.spuName
            let content = '[正品行货]' + this.goodData.spuName
            let imgLink = this.goodData.spuImgUrlList[0] + '?x-oss-process=image/resize,w_400,h_400/quality,Q_100'
            let urlLink = shareUrl + '?id=' + this.goodsId + '&organizationCode=' + this.userInfo.belongMerchantCode + '&companyCode=' + this.userInfo.companyCode + '&merchantCode=' + this.goodData.merchantCode + '&isWeixin=true' + '&type=1&invitationCode=' + this.invitationCode
            let miniprogramPath = '/goods/pages/goodDetail/index?id=' + this.goodsId + '&sourceUserId=' + this.userInfo.id
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'orderShare',
                    'title': shareTitle,
                    'desc': content,
                    'imgLink': imgLink,
                    'urlLink': urlLink,
                    'orderId': this.goodsId,
                    'miniprogramPath': miniprogramPath,
                    'miniprogramUserName': 'gh_a009e26f070f'
                })
            } else {
                window.kfxt.orderShare(
                    shareTitle,
                    content,
                    imgLink,
                    urlLink,
                    this.goodsId
                )
                window.kfxt.newOrderShare(JSON.stringify({
                    'title': shareTitle,
                    'desc': content,
                    'imgLink': imgLink,
                    'urlLink': urlLink,
                    'orderId': this.goodsId,
                    'miniprogramPath': miniprogramPath,
                    'miniprogramUserName': 'gh_a009e26f070f'
                }))
            }
        },
        onPopup (type) {
            switch (type) {
                case 3: // sku弹窗
                    if (!this.isPrice) {
                        Toast('您没有权限购买此商品')
                        return false
                    }
                    this.skuPopup = !this.skuPopup
                    break
                case 6: // 收藏
                    if (!this.isPrice) {
                        Toast('您没有权限购买此商品')
                        return false
                    }
                    let stars = !this.isStar
                    if (stars) {
                        this.addFavoriteInfo()
                    } else {
                        this.cancelFavoriteInfo()
                    }
                    this.buryPoint(15)
                    break
                case 7: // 购物车跳转
                    this.buryPoint(16)
                    this.$router.push({ path: '/b2b/cart/cart' })
                    break
                default:
                    break
            }
        },
        // 选择sku数据
        setGoodData (data) {
            this.skuGood = data
            this.$set(this.skuGood, 'quantity', data.quantity)
            this.$forceUpdate()
        },
        // 点击收藏
        async addFavoriteInfo () {
            await addFavorite({
                memberCode: this.userInfo.companyCode,
                operator: this.userInfo.id,
                productId: this.goodsId
            })
            this.isStar = true
        },
        // 取消收藏
        async cancelFavoriteInfo () {
            let productArray = []
            productArray[0] = this.goodsId
            await cancelFavorite({
                memberCode: this.userInfo.companyCode,
                operator: this.userInfo.id,
                productIds: productArray
            })
            this.isStar = false
        },
        computedPrice (skuPrice) {
            let salesPrice = []
            let retailPrice = []
            skuPrice.forEach(item => {
                salesPrice.push(item.salesPrice)
                retailPrice.push(item.retailPrice)
            })
            this.salesPrice = [...new Set(salesPrice)].sort((a, b) => {
                return a - b
            })
            this.retailPrice = [...new Set(retailPrice)].sort((a, b) => {
                return a - b
            })
        },
        async getGoodsData () {
            Toast.loading({
                duration: 0,
                message: '加载中...',
                forbidClick: true
            })
            const { data } = await getGoodsDetail({
                id: this.goodsId,
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            })
            Toast.clear()
            if (!data || data.isDeleted || !data.isOnShelf) {
                this.$router.push({ path: '/b2b/goods/error' })
                return false
            }
            const { optionValues } = data.skuDetailList[0]
            if (data.optionTypes.length !== optionValues.length) {
                let defActiveArr = Array(data.optionTypes.length).fill('')
                optionValues.forEach(item => {
                    let defIndex = data.optionTypes.findIndex(it => it.id === item.optionTypeId)
                    defActiveArr[defIndex] = item.id
                })
                this.defActive = defActiveArr
            } else {
                this.defActive = optionValues.map(item => item.id)
            }
            this.goodData = data
            this.spuInfo = { 'spuName': data.spuName, 'spuId': this.goodsId }
            this.spuSalesArea = data.spuSalesArea ? [data.spuSalesArea] : []
            this.skuDetailList = data.skuDetailList
            this.optionTypes = data.optionTypes
            this.pricesList = data.skuDetailList[0]['ladderPriceList']
            this.spuSalesAreaShow = true
            this.computedPrice(data.skuDetailList) // 阶梯价
            this.getIsPrice() // 是否可以进行购买
            this.getShopInfo() // 店铺信息
            if (data.optionTypes.length) {
                this.initSkuGood()
            } else {
                this.skuGood = data.skuDetailList[0]
            }

            // 用于客服信息
            this.goodInfo = {
                cardImage: data.spuImgUrlList[0],
                cardHeader: data.spuName,
                cardSubhead: '',
                cardPrice: '¥' + data.skuDetailList[0]['salesPrice'],
                cardUrl: ''
            }
            // 埋点
            this.buryPoint(14)
        },
        // 初始化sku
        initSkuGood () {
            let salesPrice = this.salesPrice.length > 1
                ? this.salesPrice[0] + '-' + this.salesPrice[this.salesPrice.length - 1]
                : this.salesPrice[0]
            this.skuGood = {
                skuName: this.goodData.spuName,
                skuImgUrlList: this.goodData.spuImgUrlList[0],
                salesPrice: salesPrice,
                skuCode: this.goodData.spuCode,
                quantity: 1
            }
        },
        // 店铺信息
        async getShopInfo () {
            const { data } = await shopInfo({
                merchantCode: this.goodData.merchantCode
            })
            this.shopName = data.shopName
        },
        // 是否可以进行购买
        async getIsPrice () {
            const { data } = await isPriceData({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                spuId: this.goodData.spuId
            })
            this.isPrice = data
        },
        // 商户邀请码
        async getInvitationCodeData () {
            const { data } = await getInvitationCode({
                userId: this.userInfo.id
            })
            this.invitationCode = data.merchantInvitationCode
        },
        // 是否收藏
        async isCollectInfo () {
            const { data } = await isCollect({
                memberCode: this.userInfo.companyCode,
                productId: this.goodsId
            })
            this.isStar = !!data
        },
        // 购物车数量
        cartNums () {
            this.getCartNums({ memberCode: this.userInfo.companyCode, merchantCode: this.userInfo.belongMerchantCode })
        },
        onSpecs (obj) {
            this.goodsId = obj.spuId
            this.skuPopup = false
            this.skuDetailList = []
            this.initData()
        },
        // 规格
        async getSpecsData () {
            const { data } = await getSpecs({
                spuId: this.goodsId,
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            })
            this.getSpecsList = []
            data.forEach(item => {
                if (data.status !== 2) {
                    this.getSpecsList.push(item)
                }
            })
        },
        // 埋点
        async buryPoint (event) {
            this.setBuried({
                event: event,
                goodsName: this.goodData.spuName,
                goodsCode: this.goodData.spuCode
            })
        },
        // 专题埋点
        getPoint (event, params) {
            this.setBuried({
                type: 11,
                source: 10,
                event: event,
                theme_activity_id: JSON.parse(localStorage.getItem('specialData')).id,
                theme_activity_page_title: JSON.parse(localStorage.getItem('specialData')).pageTitle,
                spuList: [{
                    'spu_code': this.goodData.spuCode,
                    'spu_id': this.goodData.spuId,
                    'spu_name': this.goodData.spuName,
                    'sku_code': this.goodData.skuCode,
                    'sku_id': this.goodData.skuId,
                    'sku_name': this.goodData.skuName
                }]
            })
        },
        initData () {
            // 获取商品详情
            this.getGoodsData()
            // 是否收藏
            this.isCollectInfo()
            // 规格
            this.getSpecsData()
        }
    },
    mounted () {
        // 获取用户信息
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        // 商品详情返回
        this.goodsDetailBack = localStorage.getItem('goodsDetailBack')
        // 是否显示分享图标
        this.appVer = !!localStorage.getItem('appVer')
        this.initData()
        // 商户邀请码
        this.getInvitationCodeData()
        // 购物车数量
        this.cartNums()
        if (this.$route.query.special) {
            localStorage.setItem('special', true)
        } else {
            localStorage.removeItem('specialData')
            localStorage.removeItem('special')
        }
    },
    beforeRouteLeave (to, from, next) {
        if (to.name !== 'goodsList') {
            clearCache('goodsList')
        }
        next()
    }
}
</script>
<style lang="scss" scoped>
.positionR {
    position: relative;
}
.goodDetail {
    font-size: 28px;
    background: #f5f5f5;
    padding-bottom: 160px;
    position: relative;
    width: 100%;
    .iconImg {
        height: 88px;
    }
    .mark {
        font-size: 28px;
        position: relative;
        background-color: #ffffff;
        height: 96px;
        line-height: 96px;
        padding: 0 32px;
        span {
            color: #000;
        }
        .item {
            float: right;
            margin-right: 40px;
            width: 480px;
            color: #333333;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
    }
    .foot {
        background: #ffffff;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 32px 32px 32px 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 9;
        &.approve {
            padding: 24px 32px;
            .btn {
                width: 100%;
                height: 90px;
                line-height: 90px;
                font-size: 34px;
                text-align: center;
                border-radius: 80px;
                color: #ffffff;
                background: #ff4d4f;
                &.active {
                    pointer-events: none;
                    cursor: default;
                    opacity: 0.6;
                }
            }
        }
    }
}
</style>
